import { createSelector } from "reselect";
import { State as AppState, StateKeys } from "rivals/redux/reducer";
import { createDeepEqualSelector } from "rivals/redux/selector";
import { College } from "rivals/shared/interfaces/College";
import { MultiSelectType } from "rivals/shared/interfaces/search";
import { State } from "./reducer";

export const getCollegesState = (state: AppState): State =>
  state[StateKeys.COLLEGES];

export const getColleges = createSelector(
  getCollegesState,
  state => state.colleges
);

export const getExitColleges = createSelector(
  getCollegesState,
  state => state.exitColleges
);

export const getOriginColleges = createSelector(
  getCollegesState,
  state => state.originColleges
);

const getCollegeOptions = (colleges: College[]): MultiSelectType[] =>
  colleges
    ? colleges.map(
        (college: College): MultiSelectType => {
          return { label: college.commonName, value: college.commonName };
        }
      )
    : [];

export const getExitCollegeSelectOptions = createDeepEqualSelector(
  getExitColleges,
  getCollegeOptions
);

export const getOriginCollegeSelectOptions = createDeepEqualSelector(
  getOriginColleges,
  getCollegeOptions
);

export const getSearching = createSelector(
  getCollegesState,
  state => state.searching
);

export const getExitCollegesSearching = createSelector(
  getCollegesState,
  state => state.exitCollegesSearching
);

export const getOriginCollegesSearching = createSelector(
  getCollegesState,
  state => state.originCollegesSearching
);
